import {
  Card,
  Row,
  Col,
  Form,
  Badge,
} from "react-bootstrap";
import { useSelector } from "react-redux";
import {
  FaUserCircle,
  FaEnvelope,
  FaCheckCircle,
  FaKey,
  FaShieldAlt,
} from "react-icons/fa";
const Profile = () => {
  const { user } = useSelector((state) => state.auth);

  return (
    <div className="container-fluid py-4 fade-in">
      <div className="mb-4">
        <h2 className="fw-bold text-dark mb-1">
          <FaUserCircle className="text-primary me-2" />
          My Profile
        </h2>
        <p className="text-muted mb-0">
          Viewing your account information and preferences
        </p>
      </div>

      <Row className="g-4">
        {/* Profile Card */}
        <Col lg={4}>
          <Card className="border-0 shadow-sm rounded-4 text-center overflow-hidden h-100">
            <div
              className="bg-primary-soft p-5 d-flex justify-content-center align-items-center"
              style={{
                background: "linear-gradient(135deg, #0C95CC 0%, #05516e 100%)",
                height: "160px",
              }}
            ></div>
            <Card.Body className="px-4 pb-4" style={{ marginTop: "-60px" }}>
              <div
                className="bg-white rounded-circle shadow-sm border border-4 border-white mx-auto d-flex align-items-center justify-content-center mb-3"
                style={{ width: "120px", height: "120px" }}
              >
                <FaUserCircle size={80} className="text-primary opacity-25" />
              </div>
              <h4 className="fw-bold mb-1 text-capitalize">{user?.username}</h4>
              <Badge
                bg="primary-soft"
                className="text-primary text-uppercase px-3 py-2 rounded-pill mb-3 border border-primary"
              >
                {user?.role}
              </Badge>
              <p className="text-muted small mb-0">
                <FaEnvelope className="me-2 text-primary" />
                {user?.email}
              </p>
            </Card.Body>
          </Card>
        </Col>

        {/* Account Details */}
        <Col lg={8}>
          <Card className="border-0 shadow-sm rounded-4 h-100 overflow-hidden">
            <Card.Header className="bg-white border-bottom py-3 px-4 d-flex justify-content-between align-items-center">
              <h6 className="fw-bold mb-0">General Information</h6>
            </Card.Header>
            <Card.Body className="p-4">
              <Form>
                <Row className="g-4">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="small fw-bold text-muted text-uppercase">
                        Username
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={user?.username}
                        readOnly
                        className="rounded-3 py-2 bg-light border-0 fw-bold"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="small fw-bold text-muted text-uppercase">
                        Email Address
                      </Form.Label>
                      <Form.Control
                        type="email"
                        value={user?.email}
                        readOnly
                        className="rounded-3 py-2 bg-light border-0 fw-bold"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="small fw-bold text-muted text-uppercase">
                        Designation
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={user?.role?.toUpperCase()}
                        readOnly
                        className="rounded-3 py-2 bg-light border-0 fw-bold"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="small fw-bold text-muted text-uppercase">
                        Department
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value="Corporate Services"
                        readOnly
                        className="rounded-3 py-2 bg-light border-0 fw-bold"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <hr className="my-5" />

                <div className="mb-4">
                  <h6 className="fw-bold mb-3 d-flex align-items-center">
                    <FaKey className="text-primary me-2" />
                    Security & Access
                  </h6>
                </div>

                <Row className="g-4">
                  <Col md={12}>
                    <div className="p-4 rounded-4 bg-light border border-dashed text-center">
                      <p className="text-muted small mb-0">
                        Your account credentials are managed by the enterprise
                        administrator. To update your password, please contact
                        your system supervisor.
                      </p>
                    </div>
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Permissions Section (for non-superadmins) */}
      {user?.role !== "superadmin" && user?.permissions?.length > 0 && (
        <Card className="border-0 shadow-sm rounded-4 mt-4 overflow-hidden">
          <Card.Header className="bg-white border-bottom py-3 px-4">
            <h6 className="fw-bold mb-0 d-flex align-items-center text-capitalize">
              <FaShieldAlt className="text-primary me-2" />
              Module Access Privileges
            </h6>
          </Card.Header>
          <Card.Body className="p-4 text-start">
            <div className="d-flex flex-wrap gap-2">
              {user.permissions.map((p) => (
                <Badge
                  key={p}
                  bg="light"
                  className="text-primary border p-2 fw-normal rounded-3"
                >
                  <FaCheckCircle className="me-2 text-success" />
                  {p.charAt(0).toUpperCase() + p.slice(1)} Module
                </Badge>
              ))}
            </div>
          </Card.Body>
        </Card>
      )}
    </div>
  );
};

export default Profile;
